<div class="container-fluid">
    <app-pagetitle title="Settings" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>

    <div class="page-content-wrapper">

        <app-loader [loading]="isLoading"></app-loader>

        <div [class.loading-content]="isLoading">

            <div class="row g-4">
                <div class="col-lg-6 d-flex">
                    <div class="card flex-fill">
                        <div class="card-header d-flex justify-content-between align-items-center">
                            <p class="fw-bold fs-5 mb-0">Platform Configuration</p>
                        </div>
                        <form [formGroup]="platformConfig" (ngSubmit)="updatePlatformConfig()">
                            <div class="card-body d-flex flex-column">

                                <div class="row mb-3">

                                    <div class="col-12 text-start mb-2">
                                        <div class="label fw-semibold mb-2">Platform Name</div>
                                        <input type="text" class="form-control" placeholder="Platform Name"
                                            formControlName="platformName" [ngClass]="{
                                            'is-invalid':
                                              platformSubmitted &&
                                              platformControls.platformName.errors
                                          }" />

                                        @if (platformSubmitted && platformControls.platformName.errors) {
                                        <div class="invalid-feedback">
                                            @if (platformControls.platformName.errors.required) {
                                            <div>Platform name is required</div>
                                            }
                                        </div>
                                        }
                                    </div>

                                    <div class="col-12 text-start mb-2">
                                        <div class="label fw-semibold mb-2">Email</div>
                                        <input type="email" class="form-control" placeholder="Email"
                                            formControlName="supportEmail" [ngClass]="{
                                                'is-invalid':
                                                  platformSubmitted &&
                                                  platformControls.supportEmail.errors
                                              }" />

                                        @if (platformSubmitted && platformControls.supportEmail.errors) {
                                        <div class="invalid-feedback">
                                            @if (platformControls.supportEmail.errors.required) {
                                            <div>Email is required</div>
                                            }
                                            @if (platformControls.supportEmail.errors) {
                                            <div>Please enter a valid email address</div>
                                            }
                                        </div>
                                        }
                                    </div>

                                    <div class="col-12 text-start mb-2">
                                        <div class="label fw-semibold mb-2">Language</div>
                                        <select class="form-select" formControlName="language" [ngClass]="{
                                    'is-invalid':
                                      platformSubmitted &&
                                      platformControls.language.errors
                                  }">
                                            <option value="" disabled>Select Language</option>
                                            <option value="en">English</option>
                                            <option value="hi">Hindi</option>
                                        </select>

                                        @if (platformSubmitted && platformControls.language.errors) {
                                        <div class="invalid-feedback">
                                            @if (platformControls.language.errors.required) {
                                            <div>Language is required</div>
                                            }
                                        </div>
                                        }
                                    </div>

                                </div>

                                <button class="btn btn-primary w-50" type="submit">
                                    Save Changes
                                </button>

                            </div>
                        </form>

                    </div>
                </div>
                <div class="col-lg-6 d-flex">
                    <div class="card flex-fill">
                        <div class="card-header d-flex justify-content-between align-items-center">
                            <p class="fw-bold fs-5 mb-0">Security Settings</p>
                        </div>

                        <form [formGroup]="securityForm" (ngSubmit)="updateSecurity()">
                            <div class="card-body d-flex flex-column">

                                <div class="row mb-3">

                                    <div class="col-12 text-start mb-2">
                                        <div class="label fw-semibold mb-2">Session Timeout (minutes)</div>
                                        <input type="number" class="form-control" placeholder="Enter session timeout"
                                            formControlName="sessionTimeout" [ngClass]="{
                                                'is-invalid':
                                                  securitySubmitted &&
                                                  securityControls.sessionTimeout.errors
                                              }" (keydown)="preventInvalidInput($event)" min="0" />

                                        @if (securitySubmitted && securityControls.sessionTimeout.errors) {
                                        <div class="invalid-feedback">
                                            @if (securityControls.sessionTimeout.errors.required) {
                                            <div>Session timeout is required</div>
                                            }
                                            @if (securityControls.sessionTimeout.errors.max) {
                                            <div>Maximum timeout is 1440 minutes (24 hours)</div>
                                            }
                                        </div>
                                        }
                                    </div>

                                    <div class="col-12 text-start mb-2">
                                        <div class="label fw-semibold mb-2">Password Policy</div>
                                        <select class="form-select" formControlName="passwordPolicy" [ngClass]="{
                                                    'is-invalid':
                                                      securitySubmitted &&
                                                      securityControls.passwordPolicy.errors
                                                  }">
                                            <option value="Strong">Strong</option>
                                            <option value="Medium">Medium</option>
                                            <option value="Basic">Basic</option>
                                        </select>

                                        @if (securitySubmitted && securityControls.passwordPolicy.errors) {
                                        <div class="invalid-feedback">
                                            @if (securityControls.passwordPolicy.errors.required) {
                                            <div>Password policy is required</div>
                                            }
                                        </div>
                                        }
                                    </div>

                                    <div class="col-12 text-start mb-2">
                                        <div class="form-check mt-2">
                                            <input class="form-check-input" type="checkbox" id="require2FAForAdmins"
                                                formControlName="require2FAForAdmins" />
                                            <label class="form-check-label fw-semibold" for="require2FAForAdmins">
                                                Enable Two-Factor Authentication (2FA)
                                            </label>
                                        </div>
                                    </div>

                                </div>

                                <button class="btn btn-primary w-50" type="submit">
                                    Save Security Settings
                                </button>

                            </div>
                        </form>

                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12 d-flex">
                    <div class="card flex-fill">
                        <div class="card-header d-flex justify-content-between align-items-center">
                            <p class="fw-bold fs-5 mb-0">Compliance Settings</p>
                        </div>

                        <div class="card-body d-flex flex-column" [formGroup]="ComplianceForm">

                            <!-- CERT-In Compliance -->
                            <div class="form-check mb-3">
                                <input class="form-check-input" type="checkbox"
                                    formControlName="certInComplianceEnabled" id="certInComplianceEnabled" />
                                <label class="form-check-label" for="certInComplianceEnabled">
                                    CERT-In Compliance Enabled
                                </label>
                            </div>

                            <!-- SOC 2 Audit Logging -->
                            <div class="form-check mb-3">
                                <input class="form-check-input" type="checkbox" formControlName="soc2AuditLogging"
                                    id="soc2AuditLogging" />
                                <label class="form-check-label" for="soc2AuditLogging">
                                    SOC 2 Audit Logging
                                </label>
                            </div>

                            <!-- GDPR Data Protection -->
                            <div class="form-check mb-3">
                                <input class="form-check-input" type="checkbox" formControlName="gdprDataProtection"
                                    id="gdprDataProtection" />
                                <label class="form-check-label" for="gdprDataProtection">
                                    GDPR Data Protection
                                </label>
                            </div>

                            <!-- ISO 27001 Compliance -->
                            <div class="form-check mb-3">
                                <input class="form-check-input" type="checkbox" formControlName="iso27001ComplianceMode"
                                    id="iso27001ComplianceMode" />
                                <label class="form-check-label" for="iso27001ComplianceMode">
                                    ISO 27001 Compliance Mode
                                </label>
                            </div>

                            <button class="btn btn-primary w-25" (click)="updateComplianceSettings()">
                                Save Compliance Settings
                            </button>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>